import { createRouter, createWebHistory } from 'vue-router'
import HomeEntry from './components/HomeEntry.vue'
import Dashboard from './components/SuperAdminDashboard.vue'
import CompanyManagement from './components/CompanyManagement.vue'
import CompanyDetail from './components/CompanyDetail.vue'
import PdfAudit from './components/PdfAudit.vue'
import SuperAdminProfile from './components/SuperAdminProfile.vue'
import Integrations from './components/Integrations.vue'
import PlanManagement from './components/PlanManagement.vue'
import PaymentLinks from './components/PaymentLinks.vue'
import ApiKeys from './components/ApiKeys.vue'
import NotFound from './components/NotFound.vue'

const routes = [
    {
        path: '/super_admin_login',
        redirect: '/'
    },
    {
        path: '/login',
        redirect: '/'
    },
    {
        path: '/',
        component: HomeEntry,
        children: [
            {
                path: '',
                name: 'Dashboard',
                component: Dashboard
            },
            {
                path: 'companies',
                name: 'Companies',
                component: CompanyManagement
            },
            {
                path: 'companies/:id',
                name: 'CompanyDetail',
                component: CompanyDetail
            },
            {
                path: 'pdfs',
                name: 'PdfAudit',
                component: PdfAudit
            },
            {
                path: 'integrations',
                name: 'Integrations',
                component: Integrations
            },
            {
                path: 'plans',
                name: 'PlanManagement',
                component: PlanManagement
            },
            {
                path: 'payment-links',
                name: 'PaymentLinks',
                component: PaymentLinks
            },
            {
                path: 'api-keys',
                name: 'ApiKeys',
                component: ApiKeys
            },
            {
                path: 'profile',
                name: 'SuperAdminProfile',
                component: SuperAdminProfile
            }
        ]
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: NotFound
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

// Navigation Guard
router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('super_admin_token')
    if (to.name === 'not-found') {
        next()
    } else if (!token && to.path !== '/') {
        next({ path: '/' })
    } else {
        next()
    }
})

export default router
